export default __webpack_public_path__ + "static/media/rating_3.1435052c.png";